export default __webpack_public_path__ + "static/media/cubyts-whole-light-no-bg.700028bc.svg";